import React from 'react';

const BoxComponent = ({ data }) => {
  // Get the current month and year
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth();
  const currentYear = currentDate.getFullYear();

  // Filter data to include only entries for the current month
  const dataForCurrentMonth = data.filter(entry => {
    const entryDate = new Date(entry.date);
    return entryDate.getMonth() === currentMonth && entryDate.getFullYear() === currentYear;
  });

  // Get the number of days in the current month
  const numDays = new Date(currentYear, currentMonth + 1, 0).getDate();

  // Generate an array of dates for the current month
  const dates = Array.from({ length: numDays }, (_, index) => new Date(currentYear, currentMonth, index + 1));

  // Find commits for each date in the current month
  const commitsForMonth = dates.map(date => {
    const commitsForDate = dataForCurrentMonth.find(entry => new Date(entry.date).getDate() === date.getDate());
    return commitsForDate ? commitsForDate.count : 0;
  });

  // Find the maximum number of commits
  const maxCommits = Math.max(...commitsForMonth, 0);
  const boxWidth = 20; // Width of each box in pixels

  // Define color ranges
  const colorRanges = [
    { min: 1, max: 4, color: 'rgb(255,64,64)' },
    { min: 5, max: 10, color: 'rgb(163, 206, 168)' },
    { min: 11, max: Infinity, color: 'rgb(114, 186, 121)' }
  ];

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
        {dates.map((date, index) => {
          // Calculate the background color based on the total count
          const backgroundColor = commitsForMonth[index] > 0
            ? getColorForCommit(commitsForMonth[index], colorRanges)
            : 'grey'; // Light grey if no commits for the date

          return (
            <div
              key={index}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginRight: '15px',
                marginBottom: '20px',
                position: 'relative', // To position tooltip
              }}
            >
              <div
                style={{
                  width: boxWidth,
                  height: boxWidth,
                  backgroundColor,
                  marginBottom: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '4px',
                  position: 'relative',
                }}
                title={`${date.toDateString()} - ${commitsForMonth[index]} commit${commitsForMonth[index] !== 1 ? 's' : ''}`}
                className="box-tooltip" // Add a class name for styling
              >
                <span style={{ color: '#fff', fontSize: '12px' }}>{commitsForMonth[index]}</span>
              </div>
              <span>{date.getDate()}</span> {/* Abbreviated date */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

// Function to get color for commit based on ranges
const getColorForCommit = (commitCount, colorRanges) => {
  for (const range of colorRanges) {
    if (commitCount >= range.min && commitCount <= range.max) {
      return range.color;
    }
  }
};

export default BoxComponent;
